import { inject, Service } from '@angular/core';
import { FileRef } from '../modules/components/fields/file-upload/file-upload.types';
import {
  customInputPayloadPatch,
  insertImageUploadFileRef,
  parseImageUploadPayload,
  patchItemInAnySection,
  serializeCustomInputPayload,
} from '../modules/checklist/utils/checklist-patches';
import { ChecklistStoreService } from './checklist-store.service';

@Service()
export class ChecklistFileRefsService {
  private readonly store = inject(ChecklistStoreService);

  mutateImageUploadFileRefs(
    checklistId: string,
    itemId: string,
    customInputId: string,
    mutate: (files: FileRef[]) => FileRef[]
  ): void {
    const checklist = this.store.latest(checklistId);
    if (!checklist) return;

    const item = checklist.sections
      .flatMap(section => section.items)
      .find(candidate => candidate.id === itemId);
    const customInput = item?.customInputs?.find(
      candidate => candidate.id === customInputId
    );
    if (!customInput) return;

    const payload = parseImageUploadPayload(customInput.payload);
    const updatedPayload = {
      ...payload,
      files: mutate(payload.files),
    };
    const serializedPayload = serializeCustomInputPayload(updatedPayload);
    this.store.update(
      patchItemInAnySection(checklist, itemId, item =>
        customInputPayloadPatch(item, customInputId, serializedPayload)
      )
    );
  }

  removeImageUploadFileRef(
    checklistId: string,
    itemId: string,
    customInputId: string,
    fileId: string
  ): void {
    this.mutateImageUploadFileRefs(checklistId, itemId, customInputId, files =>
      files.filter(file => file.id !== fileId)
    );
  }

  restoreImageUploadFileRef(
    checklistId: string,
    itemId: string,
    customInputId: string,
    fileRef: FileRef,
    fileIndex?: number,
    fileOrder?: string[]
  ): void {
    this.mutateImageUploadFileRefs(checklistId, itemId, customInputId, files =>
      insertImageUploadFileRef(files, fileRef, fileIndex, fileOrder)
    );
  }
}
